export default "/assets/08a9a82c7393d843.svg"